import React from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { Mail, Clock } from 'lucide-react';
export function ContactPage() {
  return <Layout data-id="element-341">
      <div className="bg-gradient-to-br from-slate-50 to-teal-50 py-16" data-id="element-342">
        <div className="container mx-auto px-4 text-center" data-id="element-343">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-344">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-345">
              Contact Us
            </h1>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-346">
              Our team replies within one working day.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-347">
        <div className="max-w-4xl mx-auto" data-id="element-348">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-349">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm text-center" data-id="element-350">
              <div className="inline-flex p-3 bg-teal-50 text-teal-600 rounded-full mb-4" data-id="element-351">
                <Mail size={24} data-id="element-352" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2" data-id="element-353">Email</h3>
              <a href="mailto:rokkaishma1@gmail.com" className="text-teal-600 hover:text-teal-700 text-sm break-all" data-id="element-354">
                rokkaishma1@gmail.com
              </a>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm text-center" data-id="element-355">
              <div className="inline-flex p-3 bg-teal-50 text-teal-600 rounded-full mb-4" data-id="element-356">
                <Clock size={24} data-id="element-357" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2" data-id="element-358">Hours</h3>
              <p className="text-slate-600 text-sm" data-id="element-359">
                Mon-Fri
                <br data-id="element-360" />
                9am - 5pm
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-12 rounded-2xl border border-slate-200 shadow-sm" data-id="element-361">
            <h2 className="text-2xl font-bold text-slate-900 mb-2 text-center" data-id="element-362">
              Send Us a Message
            </h2>
            <p className="text-slate-600 text-center mb-8" data-id="element-363">
              Fill in the form below and we'll get back to you shortly.
            </p>

            <form className="space-y-6" data-id="element-364">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-365">
                <div data-id="element-366">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-367">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all" placeholder="Your name" data-id="element-368" />
                </div>
                <div data-id="element-369">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-370">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all" placeholder="your@email.com" data-id="element-371" />
                </div>
              </div>

              <div data-id="element-372">
                <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-373">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all" placeholder="How can we help?" data-id="element-374" />
              </div>

              <div data-id="element-375">
                <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-376">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all resize-none" placeholder="Tell us more about your enquiry..." data-id="element-377"></textarea>
              </div>

              <button type="submit" className="w-full h-12 px-6 rounded-lg bg-teal-600 text-white font-medium hover:bg-teal-700 transition-colors shadow-sm" data-id="element-378">
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </Layout>;
}